import { apiPost } from "@/lib/http/client";
import type {
  CreditNoteSearchRequest,
  CreditNoteSearchResponse,
} from "@/types/api";

export async function searchCreditNotes(body: CreditNoteSearchRequest) {
  return apiPost<CreditNoteSearchResponse>("/credit-notes/search", body);
}
